import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy
} from "@angular/core";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { IGraph, graphsData } from "../graph-config";
import {
  Tag,
  TagColor,
  CardComponent
} from "../../../elements/card/card.component";

@Component({
  selector: "app-graph-library",
  templateUrl: "./graph-library.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./graph-library.component.scss"],
  imports: [CardComponent, TranslateModule]
})
export class GraphLibraryComponent implements OnInit {
  @Output() graphSelected = new EventEmitter<IGraph>();
  @Input() filteredCharts: IGraph[] = [];
  @Input() searchTerm: string = "";

  charts: IGraph[] = graphsData;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  onChartSelected(chart: IGraph) {
    this.graphSelected.emit(chart);
  }

  getChartTitle(chart: IGraph): string {
    return (
      this.translate.instant(`analytics.navigator.${chart.name}.cardTitle`) ||
      chart.name
    );
  }

  getChartDescription(chart: IGraph): string {
    return (
      this.translate.instant(`analytics.navigator.${chart.name}.description`) ||
      `Graphique ${chart.name}`
    );
  }

  getChartTags(chart: IGraph): Tag[] {
    const tags: Tag[] = [];

    if (chart.tags.isHistorical)
      tags.push({
        label: this.translate.instant("analytics.tags.isHistorical"),
        color: TagColor.grey
      });
    else if (chart.tags.isHistorical === false)
      tags.push({
        label: this.translate.instant("analytics.tags.isnotHistorical"),
        color: TagColor.green
      });

    if (chart.tags.isStellantis)
      tags.push({
        label: this.translate.instant("analytics.tags.isStellantis"),
        color: TagColor.blue
      });
    else if (chart.tags.isStellantis === false)
      tags.push({
        label: this.translate.instant("analytics.tags.isnotStellantis"),
        color: TagColor.orange
      });

    if (chart.tags.isStock)
      tags.push({
        label: this.translate.instant("analytics.tags.isStock"),
        color: TagColor.teal
      });
    else if (chart.tags.isStock === false)
      tags.push({
        label: this.translate.instant("analytics.tags.isnotStock"),
        color: TagColor.purple
      });

    return tags;
  }
}
